import * as yup from "yup";

const schema = yup.object().shape({
  // type
  propertyType: yup.string().required(),
  propertySubType: yup.string().required(),
  city: yup.string().required(),
  address: yup.string().required(),
  // details
  propertyTitle: yup.string().required(),
  rentalPrice: yup.string().required(),
  sellingPrice: yup.string().required(),
  landArea: yup.string().required(),
  landAreaLength: yup.string().required(),
  landAreaWidth: yup.string().required(),
  landAreaUnit: yup.string().required(),
  bedrooms: yup.string().required(),
  bathrooms: yup.string().required(),
  // contact
  name: yup.string().min(3).required(),
  phone: yup.string().max(16).required(),
  // type: yup.string().min(1).required(),
  // land: yup.string().min(2).required(),
  // rooms: yup.number().required(),
  // washroom: yup.number().required(),
  // studyroom: yup.number().required(),
  // demand: yup.string().required(),
  // description: yup.string().required(),
});

export default schema;
